export default [
    "20 20",
    '<path d="M15.8327 10.2464H4.16602M4.16602 10.2464L9.99935 16.0798M4.16602 10.2464L9.99935 4.41309" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)"  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>']